var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrice16Blue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2.66699H2.66683C1.92683 2.66699 1.34016 3.26033 1.34016 4.00033L1.3335 12.0003C1.3335 12.7403 1.92683 13.3337 2.66683 13.3337H13.3335C14.0735 13.3337 14.6668 12.7403 14.6668 12.0003V4.00033C14.6668 3.26033 14.0735 2.66699 13.3335 2.66699ZM13.3335 12.0003H2.66683V8.00033H13.3335V12.0003ZM13.3335 5.33366H2.66683V4.00033H13.3335V5.33366Z",
    fill: "#0077CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice16Blue);
export default __webpack_public_path__ + "static/media/icon-price-16-blue.8ed0d69545f54bfc27b3df80369f0e48.svg";
export { ForwardRef as ReactComponent };